export default (r, scale) => {
  return r.merge({
    left: Math.ceil(r.left * scale),
    right: Math.ceil(r.right * scale),
    width: Math.ceil(r.width * scale),
    top: Math.ceil(r.top * scale),
    bottom: Math.ceil(r.bottom * scale),
    height: Math.ceil(r.height * scale)
  });
};
